import React from 'react';
import About from './About';

function PrincipalsDesk() {
  return <About />;
}

export default PrincipalsDesk;
